export function sortByIndex(arrayToSort, arrayForIndexes) {
  return arrayToSort.sort((a, b) => {
    const indexA = arrayForIndexes.indexOf(a);
    const indexB = arrayForIndexes.indexOf(b);

    return indexA - indexB;
  });
}
